import clsx from 'clsx'
import type { ButtonHTMLAttributes } from 'react'

import s from './IconButton.module.css'

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { title: string }

export function IconButton({ className, title, children, ...props }: IconButtonProps) {
  return (
    <button
      type="button"
      className={clsx(s.button, className)}
      title={title}
      aria-label={title}
      {...props}
    >
      {children}
    </button>
  )
}
